import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";
import { isNil } from "lodash-es";
const __script_base__ = {
  name: 'UcTag',
  model: {
    prop: 'text'
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'normal'
    },
    color: {
      type: String,
      default: '#0F8EE9'
    },
    icon: {
      type: String,
      default: ''
    },
    handleClick: {
      type: Function,
      default: null
    }
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  computed: {
    isEmptyTag() {
      return isNil(this.text) || !String(this.text);
    },
    outerStyle() {
      const style = {};
      if (this.type === 'custom') {
        style['--uc-tag-color'] = this.color;
      }
      if (this.isEmptyTag) {
        if (this.uc.isDesignMode) style.opacity = '0.5';else style.display = 'none';
      }
      return style;
    },
    tagClass() {
      const list = ['uc-tag'];
      list.push(this.type !== 'custom' ? `isPreset type-${this.type}` : 'isCustom');
      if (this.handleClick) list.push('clickable');
      return list;
    },
    sanityText() {
      return this.isEmptyTag ? '空标签' : String(this.text);
    }
  },
  methods: {
    handleTagClick(e) {
      if (this.handleClick) {
        var _this$$el;
        this.handleClick(String(this.text), e);
        (_this$$el = this.$el) === null || _this$$el === void 0 || (_this$$el = _this$$el.classList) === null || _this$$el === void 0 || _this$$el.add('clicked');
        setTimeout(() => {
          var _this$$el2;
          (_this$$el2 = this.$el) === null || _this$$el2 === void 0 || (_this$$el2 = _this$$el2.classList) === null || _this$$el2 === void 0 || _this$$el2.remove('clicked');
        }, 200);
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: _vm.tagClass,
    style: _vm.outerStyle,
    on: {
      "click": _vm.handleTagClick
    }
  }, [_c('span', {
    staticClass: "uc-tag-text"
  }, [_vm.icon ? _c('i', {
    class: "fa fa-" + this.icon
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.sanityText) + "\n  ")])]);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Tag/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);